module.exports = __webpack_public_path__ + "assets/video/peytil.9b1def7.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/peytil.webm
// module id = 350
// module chunks = 0